import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class FunilValidation extends DefaultValidation{
    validate(model, refs) {
        let validated = true;

        if(refs.idfunilerpInput.required && Util.isNull(model.idFunilErp)) {
            refs.idfunilerpInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        

        return validated;
    }
}